import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';
const DEFAULT_STEP = 'SOCIAL';
const DEFAULT_USER_ID = '';
const createDefaultAccountDetails = () => ({});
const STORAGE_KEY = 'register-wizard-step';
const normalizeStep = (step) => {
    if (step === 'MFA_CODE') {
        return 'MFA_PHONE';
    }
    if (step === 'SOCIAL' || step === 'ACCOUNT' || step === 'MFA_PHONE' || step === 'DONE') {
        return step;
    }
    return DEFAULT_STEP;
};
const createNoopStorage = () => ({
    length: 0,
    clear: () => {
        /* noop */
    },
    getItem: () => null,
    key: () => null,
    removeItem: () => {
        /* noop */
    },
    setItem: () => {
        /* noop */
    },
});
const getInitialState = () => {
    if (typeof window === 'undefined') {
        return {
            step: DEFAULT_STEP,
            userId: DEFAULT_USER_ID,
            accountDetails: createDefaultAccountDetails(),
        };
    }
    try {
        const raw = window.sessionStorage.getItem(STORAGE_KEY);
        if (!raw) {
            return {
                step: DEFAULT_STEP,
                userId: DEFAULT_USER_ID,
                accountDetails: createDefaultAccountDetails(),
            };
        }
        const parsed = JSON.parse(raw);
        return {
            step: normalizeStep(parsed?.state?.step),
            userId: parsed?.state?.userId ?? DEFAULT_USER_ID,
            accountDetails: parsed?.state?.accountDetails ?? createDefaultAccountDetails(),
        };
    }
    catch {
        return {
            step: DEFAULT_STEP,
            userId: DEFAULT_USER_ID,
            accountDetails: createDefaultAccountDetails(),
        };
    }
};
const createStorage = () => typeof window === 'undefined'
    ? createJSONStorage(() => createNoopStorage())
    : createJSONStorage(() => {
        try {
            return window.sessionStorage;
        }
        catch {
            return createNoopStorage();
        }
    });
const initialState = getInitialState();
export const useRegisterWizardStore = create()(persist((set) => ({
    step: initialState.step,
    userId: initialState.userId,
    accountDetails: initialState.accountDetails,
    setStep: (nextStep) => set({ step: normalizeStep(nextStep) }),
    setUserId: (nextUserId) => set({ userId: nextUserId || DEFAULT_USER_ID }),
    setAccountDetails: (details) => set({ accountDetails: { ...details } }),
    clearAccountDetails: () => set({ accountDetails: createDefaultAccountDetails() }),
    reset: () => set({
        step: DEFAULT_STEP,
        userId: DEFAULT_USER_ID,
        accountDetails: createDefaultAccountDetails(),
    }),
}), {
    name: STORAGE_KEY,
    storage: createStorage(),
    version: 1,
    partialize: (state) => ({
        step: state.step,
        userId: state.userId,
        accountDetails: state.accountDetails,
    }),
    merge: (persistedState, currentState) => {
        const nextState = persistedState;
        return {
            ...currentState,
            ...nextState,
            step: normalizeStep(nextState?.step),
            userId: nextState?.userId ?? currentState.userId,
            accountDetails: nextState?.accountDetails ?? currentState.accountDetails,
        };
    },
}));
//# sourceMappingURL=useRegisterWizardStore.js.map